export default __webpack_public_path__ + "static/764-d74b9233514858753b827645fa7c2f52.gif";